import React, { Component, useState, useEffect,useCallback, useRef } from 'react'
import Dropzone from 'react-dropzone'

import 'jbc-front/styles/react-select.scss'
import Select, { Creatable } from 'react-select'
import moment from 'moment'

import 'react-datetime/css/react-datetime.css'
import DateTime from 'react-datetime'
import historykana from 'historykana'
import { Field, change as formChange } from 'redux-form'
import * as validators from 'src/jbc-front/utils/validators'
import { toJpYearDate, toAdYearDate } from 'jbc-front/utils/jpYear'
import { LabelMapper } from 'jbc-front/components/FormErrors'
import { Calendar, Fileup, Delete, CheckForm } from 'jbc-front/components/icons'
import styles from './Form.scss'
import omit from 'lodash/omit'
import isString from 'lodash/isString'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import isEmpty from 'lodash/isEmpty'
import last from 'lodash/last'
import uniqueId from 'lodash/uniqueId'
import get from 'lodash/get'
import Hint from 'jbc-front/components/Hint'
import { withTranslation, useTranslation } from 'react-i18next';
import * as customValidators from '../../utils/CustomValidators'
import Cropper from "react-easy-crop"
import Modal from 'jbc-front/components/Modal';

const Diff = ({ diff, options }) =>
  diff ? (
    <div className={styles.diffField}>
      <p className={styles.diffLabelText}>変更前</p>
      <p>{isEmpty(options) ? diff : options[diff] || diff}</p>
    </div>
  ) : null

export const Required = () => {
  const { t } = useTranslation();
  return (
    <span className={styles.required}>{t('jbc-front.components.Form.required')}</span>
  )
}

export const Label = ({ text, required, note, noteWidth, changed, noLabel, diff, labelStyle }) => (
  <React.Fragment>
    {!noLabel && (
      <label className={styles.label} style={labelStyle}>
        <span>{text}</span>
        {required && <Required />}
        {note && <Hint text={note} width={noteWidth} />}
        {(changed || diff) && (
          <span className={styles.changed}>
            <CheckForm />
            承認待ち
          </span>
        )}
      </label>
    )}
  </React.Fragment>
)

export const renderCheckBoxField = ({
  input,
  label,
  meta,
  labelContent,
  note,
  noteWidth,
  disabled,
  diff,
  changed,
  description
}) => (
  <div>
    <label className="input-label">
      <input
        {...input}
        placeholder={label}
        type="checkbox"
        checked={input.value}
        className="m-checkbox-input"
        disabled={disabled}
      />
      <span className="m-checkbox-parts">{labelContent ? labelContent : label}</span>
    </label>
    {note && <Hint text={note} width={noteWidth} />}
    {(changed || diff) && (
      <span className={styles.changed}>
        <CheckForm />
        承認待ち
      </span>
    )}
    <Diff diff={diff} />
    {description && <div className={styles.description}>{description}</div>}
    <Error meta={meta} label={label} />
  </div>
)

export const renderInputField = ({
  input,
  label,
  type,
  required,
  meta,
  readOnly,
  disabled,
  note,
  noteWidth,
  maxLength,
  yen,
  placeholder,
  icons,
  diff,
  changed,
  noLabel,
  description,
  isChangeLabelToAnchor,
  width,
  textAlign,
  labelStyle
}) => (
  <div>
    <Label
      text={label}
      required={required}
      note={note}
      noteWidth={noteWidth}
      changed={changed}
      diff={diff}
      noLabel={noLabel}
      isChangeLabelToAnchor={isChangeLabelToAnchor}
      labelStyle={labelStyle}
    />
    <div className={styles.fieldWrap}>
      <div className={styles.icnTextarea}>
        {yen && <i className={styles.yen}>VND</i>}
        <input
          {...{ readOnly, disabled, type, ...input }}
          className={meta.error && meta.touched ? styles.invalid : ''}
          maxLength={maxLength}
          placeholder={placeholder}
          style={{width: width? `${width}px` : "100%", textAlign: textAlign? textAlign : "left"}}
        />
      </div>
      {icons && <div className={styles.icons}>{icons}</div>}
    </div>
    <Diff diff={diff} />
    {description && <div className={styles.description}>{description}</div>}
    <Error meta={meta} label={label} />
  </div>
)

export const renderInputFieldWithKana = props => {
  const { input, onUpdateKana } = props
  const [history, setHistory] = useState([])
  useEffect(
    () => {
      if (input.value) {
        setHistory(history => [...history, input.value])
      } else {
        setHistory([])
        onUpdateKana('')
      }
    },
    [input.value]
  )
  useEffect(
    () => {
      const kana = history.length > 0 ? historykana(history) : ''
      if (kana) onUpdateKana(kana)
    },
    [history]
  )
  const InputField = renderInputField
  return <InputField {...props} />
}

export const renderInlineInputField = ({ input, type, width, maxLength, meta: { touched, error }, disabled }) => (
  <input
    {...input}
    type={type}
    style={{ display: 'inline-block', width: `${width}px` }}
    maxLength={maxLength}
    className={touched && error ? styles.invalid : ''}
    disabled={disabled}
  />
)

export const renderRadioField = ({
  label,
  input,
  options,
  disabled: disabledAll,
  required,
  meta,
  note,
  noteWidth,
  diff,
  changed,
  description,
  isChangeLabelToAnchor
}) => (
  <div>
    <div className={styles.radio}>
      <Label
        text={label}
        required={required}
        note={note}
        noteWidth={noteWidth}
        changed={changed}
        diff={diff}
        isChangeLabelToAnchor={isChangeLabelToAnchor}
      />
      <div>
        {options.map(({ label, value, note, noteWidth, disabled: disabledOption }) => {
          const disabled = disabledAll || disabledOption
          return (
            <div style={{ display: 'inline-block' }} className="input-label" key={value}>
              <label>
                <input
                  {...omit(input, 'value')}
                  type="radio"
                  value={value}
                  checked={value == input.value}
                  disabled={disabled}
                  className={`m-radio-input${disabled ? ' disabled' : ''}`}
                />
                <span className={`m-radio-parts${disabled ? ' disabled' : ''}`}>{label}</span>
              </label>
              {note && <Hint text={note} width={noteWidth} />}
            </div>
          )
        })}
      </div>
    </div>
    <Diff diff={diff} options={options} />
    {description && <div className={styles.description}>{description}</div>}
    <Error meta={meta} label={label} />
  </div>
)

export const renderRadioFieldWithIssuedDate = (props) => {
  const { t } = useTranslation();
  const {
    label = t('jbc-front.components.IssuedDate.issued_date'),
    labelNonspecified = t('jbc-front.components.IssuedDate.non_specified'),
    labelIssuedDate = t('jbc-front.components.IssuedDate.specify_issue_date'),
    required,
    input,
    note,
    noteWidth,
    diff,
    changed,
    description,
    isChangeLabelToAnchor,
    dateFormat = 'YYYY/MM/DD',
  } = props;

  const OPTIONS = {
    none: 'nonspecified',
    issuedDate: 'issuedDate',
  }

  const [selectedOption, setSelectedOption] = useState(OPTIONS.none);
  const [issuedDate, setIssuedDate] = useState(null);
  const [issuedDateError, setIssuedDateError] = useState(null);
  const [issuedDateTouched, setIssuedDateTouched] = useState(false);
  const datetimeRef = useRef(null);

  const getTodayDate = () => {
    return moment().format(dateFormat);
  };

  const handleChangeDate = (date) => {
    setSelectedOption(OPTIONS.issuedDate);
    if (typeof date === 'string') {
      setIssuedDate(date);
      input.onChange(date);
    } else {
      setIssuedDate(date.format(dateFormat));
      input.onChange(date.format(dateFormat));
    }
  };

  const handleClickNone = (e) => {
    setIssuedDateError(null);
    setIssuedDateTouched(false);
    setSelectedOption(e.target.value);
    setIssuedDate(null);
    input.onChange('');
  };

  useEffect(() => {
    if (issuedDateTouched) {
      setIssuedDateError(customValidators.isDateStringFormat(issuedDate));
    }
  }, [issuedDate]);

  return (
    <div>
      <div className={styles.radio}>
        <Label
          text={label}
          required={required}
          note={note}
          noteWidth={noteWidth}
          changed={changed}
          diff={diff}
          isChangeLabelToAnchor={isChangeLabelToAnchor}
        />
        <div>
          <div style={{ display: 'inline-block' }} className="input-label">
            <label>
              <input
                type="radio"
                value={OPTIONS.none}
                checked={selectedOption == OPTIONS.none}
                // disabled={disabled}
                onChange={handleClickNone}
                className={`m-radio-input`}
              />
              <span className={`m-radio-parts`}>{labelNonspecified}</span>
            </label>
            {note && <Hint text={note} width={noteWidth} />}
          </div>
          <div style={{ display: 'inline-block' }} className="input-label">
            <label>
              <input
                type="radio"
                value={OPTIONS.issuedDate}
                checked={selectedOption == OPTIONS.issuedDate}
                onChange={(e) => {
                  setSelectedOption(e.target.value);
                  if (!issuedDate) {
                    setIssuedDate(getTodayDate());
                    input.onChange(getTodayDate());
                    return;
                  }
                  input.onChange(issuedDate);
                }}
                className={`m-radio-input`}
              />
              <span className={`m-radio-parts`} style={{ backgroundSize: '16px 35px' }}>
                <div
                  className={
                    issuedDateTouched && issuedDateError
                      ? `${styles.icnTextarea} ${styles.invalid}`
                      : `${styles.icnTextarea}`
                  }
                >
                  <DateTime
                    onChange={(value) => {
                      handleChangeDate(value);
                      setIssuedDateTouched(true);
                    }}
                    value={issuedDate}
                    locale="en"
                    dateFormat={dateFormat}
                    timeFormat={false}
                    closeOnSelect={true}
                    inputProps={{
                      placeholder: labelIssuedDate,
                    }}
                    ref={(ref) => {
                      datetimeRef.current = ref;
                    }}
                  />
                  <i onClick={() => datetimeRef.current && datetimeRef.current.openCalendar()}>
                    <Calendar />
                  </i>
                </div>
              </span>
            </label>
          </div>
        </div>
      </div>
      {/* <Diff diff={diff} options={options} /> */}
      {description && <div className={styles.description}>{description}</div>}
      <Error meta={{ touched: issuedDateTouched, error: issuedDateError }} label={label} />
    </div>
  );
};

// const JpYearDate = ({ value }) => {
//   const dateMatch = value.match(validators.adYearRegExp)
//   if (dateMatch && moment(value, 'YYYY/MM/DD').isValid()) {
//     const date = new Date(dateMatch[1], Number(dateMatch[2]) - 1, dateMatch[3])
//     return <span className={styles.jpYear}>{toJpYearDate(date)}</span>
//   }
//   return null
// }

export class renderDatePickerField extends Component {
  render() {
    const {
      input,
      label,
      required,
      meta,
      note,
      noteWidth,
      dateFormat = 'DD/MM/YYYY',
      diff,
      changed,
      example,
      description,
      isChangeLabelToAnchor,
      disabled,
      ...rest
    } = this.props
    return (
      <div>
        <Label
          text={label}
          required={required}
          note={note}
          noteWidth={noteWidth}
          changed={changed}
          diff={diff}
          isChangeLabelToAnchor={isChangeLabelToAnchor}
        />
        <div
          className={meta.touched && meta.error ? `${styles.icnTextarea} ${styles.invalid}` : `${styles.icnTextarea}`}>
          {disabled ? (
            <input type="text" name={input.name} value={input.value} disabled />
          ) : (
            <DateTime
              locale='en'
              value={input.value}
              onChange={param => {
                input.onChange(param)
              }}
              onBlur={() => {
                if (input.value.match(validators.jpYearRegExp)) {
                  input.value = toAdYearDate(input.value)
                }
                input.onBlur(input.value)
              }}
              dateFormat={dateFormat}
              timeFormat={false}
              {...rest}
              ref={dateTime => (this._dateTime = dateTime)}
            />
          )}

          {/* <JpYearDate value={input.value} /> */}
          <i onClick={() => this._dateTime && this._dateTime.openCalendar()}>
            <Calendar />
          </i>
        </div>
        <Diff diff={diff} />
        {example && <span className={styles.example}>{example}</span>}
        {description && <div className={styles.description}>{description}</div>}
        <Error meta={meta} label={label} />
      </div>
    )
  }
}

export class renderInlineDatePickerField extends Component {
  render() {
    const { input, meta: { touched, error }, options, width, ...rest } = this.props
    return (
      <div
        className={touched && error ? `${styles.icnTextarea} ${styles.invalid}` : `${styles.icnTextarea}`}
        style={{ width: `${width}px`, display: 'inline-block' }}>
        <DateTime
          locale='en'
          value={input.value}
          onChange={param => input.onChange(param)}
          onBlur={() => {
            if (input.value.match(validators.jpYearRegExp)) {
              input.value = toAdYearDate(input.value)
            }
            input.onBlur(input.value)
          }}
          dateFormat={'YYYY/MM/DD'}
          timeFormat={false}
          {...options}
          ref={dateTime => (this._dateTime = dateTime)}
          {...rest}
        />
        <i onClick={() => this._dateTime.openCalendar()}>
          <Calendar />
        </i>
      </div>
    )
  }
}

export const renderTextAreaField = ({
  input,
  meta: { touched, error },
  label,
  placeholder = '',
  type,
  meta,
  rows = '10',
  icons,
  required,
  disabled,
  note,
  noteWidth,
  description,
  isChangeLabelToAnchor
}) => (
  <div>
    <Label
      text={label}
      required={required}
      note={note}
      noteWidth={noteWidth}
      isChangeLabelToAnchor={isChangeLabelToAnchor}
    />
    <div className={styles.fieldWrap}>
      <div className={touched && error ? `${styles.icnTextarea} ${styles.invalid}` : `${styles.icnTextarea}`}>
        <textarea {...input} placeholder={placeholder} type={type} rows={rows} disabled={disabled} />
      </div>
      {icons && <div className={styles.icons}>{icons}</div>}
    </div>
    {description && <div className={styles.description}>{description}</div>}
    <Error meta={meta} label={label} />
  </div>
)

const urlRegex = /https?:\/\/([^\s/?]+\.?)+(\/[^\s]*)?/

const renderAnchor = (url, idx) => (
  <a href={url} key={idx} target="_blank" className="u-txt-link" rel="noopener noreferrer">
    {url}
  </a>
)

export const renderTextWithAnchor = (text, idx = 0) => {
  const matchUrl = text.match(urlRegex)
  return matchUrl
    ? [
        text.slice(0, matchUrl.index),
        renderAnchor(matchUrl[0], idx),
        ...renderTextWithAnchor(text.slice(matchUrl.index + matchUrl[0].length), idx + 1)
      ]
    : [text]
}

export const arrowRenderer = ({ isOpen }) => (
  <i>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      transform={isOpen ? 'rotate(180)' : 'rotate(0)'}>
      <path fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2" d="M3.5 7l6.2 6.3L16 7" />
    </svg>
  </i>
)

const renderSelectField = ({
  input,
  required,
  label,
  meta,
  creatable,
  asyncOptions,
  options,
  note,
  noteWidth,
  placeholder = 'Please select',
  addBlankOption = !required,
  diff,
  changed,
  noLabel,
  description,
  isChangeLabelToAnchor,
  ...rest
}) => {
  const [addedOptions, setAddOptions] = useState([])
  useEffect(
    () => {
      if (
        creatable &&
        input.value &&
        !options.find(option => option.value === input.value) &&
        !addedOptions.find(option => option.value === input.value)
      ) {
        setAddOptions(addedOptions => [...addedOptions, { label: input.value, value: input.value }])
      }
    },
    [input.value, options, addedOptions, creatable]
  )

  let _options = addBlankOption ? [{ label: '\u200b', value: null }, ...options] : options

  const diffOption = options.find(option => option.value === diff)

  const Input = (creatable && Creatable) || (asyncOptions && Select.Async) || Select
  if (creatable) {
    _options = [..._options, ...addedOptions]
    rest.onNewOptionClick = option => {
      setAddOptions(addedOptions => [...addedOptions, option])
    }
    rest.promptTextCreator = label => `「${label}」を追加します`
  }
  return (
    <div className={meta.touched && meta.error ? `${styles.icnTextarea} ${styles.invalid}` : `${styles.icnTextarea}`}>
      <Label
        text={label}
        required={required}
        note={note}
        noteWidth={noteWidth}
        changed={changed}
        diff={diff}
        noLabel={noLabel}
        isChangeLabelToAnchor={isChangeLabelToAnchor}
      />
      <Input
        name={input.name}
        value={input.value}
        onChange={input.onChange}
        onBlur={() => input.onBlur(input.value)}
        options={_options}
        placeholder={placeholder}
        simpleValue
        arrowRenderer={arrowRenderer}
        clearable={false}
        noResultsText="Data not found"
        noOptionsMessage="Data not found"
        {...rest}
      />
      <Diff diff={get(diffOption, 'label') || diff} />
      {description && <div className={styles.description}>{description}</div>}
      <Error meta={meta} label={label} />
    </div>
  )
}

export const Error = ({ meta: { touched, error }, label = '' }) => (
  <React.Fragment>
    {touched ? (
      error ? (
        <p className={styles.error}>
          <span>{`${label}${error}`}</span>
        </p>
      ) : null
    ) : null}
  </React.Fragment>
)

export const Note = ({ text }) => <p className={styles.note}>{text}</p>

const File = ({ file, invalid, onClick, disabled }) => (
  <div className={invalid ? `${styles.icnTextarea} ${styles.invalid} u-mt20` : `${styles.icnTextarea} u-mt20`}>
    {!disabled && (
      <i onClick={onClick}>
        <Delete size={20} />
      </i>
    )}
    <div className={`${styles.input} ${styles.disabled}`}>
      {file.url ? (
        <a href={file.url} download className={styles.downloadLink} target="_blank" rel="noopener noreferrer">
          {file.filename}
        </a>
      ) : (
        file.name
      )}
    </div>
  </div>
)

export class renderFileField extends Component {
  static defaultProps = {
    accepted: '*',
    multiple: false,
    disablePreview: true
  }

  onDrop = acceptedFiles => {
    if (acceptedFiles) {
      this.setState({ files: acceptedFiles })
    }
    const { multiple, input: { onChange, value } } = this.props
    acceptedFiles.forEach(file => (file._id = uniqueId('file_')))
    return multiple ? onChange([...value, ...acceptedFiles]) : onChange(acceptedFiles[0])
  }

  handleBlur = () => {
    const { input: { onBlur, value } } = this.props
    return onBlur(value)
  }

  clear = () => {
    const { input: { onChange } } = this.props
    return onChange(null)
  }

  remove = index => {
    const { input: { value, onChange } } = this.props
    onChange(value.filter((file, i) => i !== index))
  }

  render() {
    /* eslint-disable no-unused-vars */
    const {
      input: { onBlur, value },
      required,
      meta,
      label,
      name,
      accept,
      multiple,
      note,
      noteWidth,
      disabled,
      disablePreview,
      diff,
      changed,
      description,
      isChangeLabelToAnchor,
      noValuePreview
    } = this.props
    /* eslint-enable no-unused-vars */
    const Preview = this.props.preview

    return (
      <div>
        <Label
          text={label}
          required={required}
          note={note}
          noteWidth={noteWidth}
          changed={changed}
          diff={diff}
          isChangeLabelToAnchor={isChangeLabelToAnchor}
        />
        {!disabled && (
          <Dropzone
            accept={accept}
            onBlur={this.handleBlur}
            onDrop={this.onDrop}
            name={name}
            multiple={multiple}
            className="dropzone-input"
            disablePreview={disablePreview}>
            <div className={styles.icnTextarea}>
              <i>
                <Fileup />
              </i>
              <input
                type="text"
                className={meta.error && meta.touched ? styles.invalid : ''}
                readOnly
                placeholder={this.props.t('jbc-front.components.Form.Select_file_or_drag_and_drop')}
                value=""
              />
            </div>
          </Dropzone>
        )}
        {!noValuePreview && value &&
          (multiple ? (
            value.map((file, index) => (
              <File
                key={file.id || file._id}
                file={file}
                onClick={() => this.remove(index)}
                error={meta.touched && meta.error}
                disabled={disabled}
              />
            ))
          ) : (
            <File file={value} onClick={this.clear} error={meta.touched && meta.error} disabled={disabled} />
          ))}
        {!noValuePreview && !value && disabled && <input disabled type="text" />}
        {description && <div className={styles.description}>{description}</div>}
        <Error meta={meta} label={label} />
        {Preview && value && <Preview value={value} />}
      </div>
    )
  }
}
const createImage = url =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', error => reject(error))
    image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
    image.src = url
  })

async function getCroppedImg(imageSrc, pixelCrop) {
  const getImageExtension =  imageSrc.substring("data:image/".length , imageSrc.indexOf(';base64'))
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  const maxSize = Math.max(image.width, image.height)
  const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2))

  // set each dimensions to double largest dimension to allow for a safe area for the
  // image to rotate in without being clipped by canvas context
  canvas.width = safeArea
  canvas.height = safeArea

  // translate canvas context to a central location on image to allow rotating around the center.
  ctx.translate(safeArea / 2, safeArea / 2)
  ctx.translate(-safeArea / 2, -safeArea / 2)

  // draw rotated image and store data.
  ctx.drawImage(
    image,
    safeArea / 2 - image.width * 0.5,
    safeArea / 2 - image.height * 0.5
  )
  const data = ctx.getImageData(0, 0, safeArea, safeArea)

  // set canvas width to final desired crop size - this will clear existing context
  canvas.width = pixelCrop.width
  canvas.height = pixelCrop.height

  // paste generated rotate image with correct offsets for x,y crop values.
  ctx.putImageData(
    data,
    Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
    Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)
  )

  // As Base64 string
  // return canvas.toDataURL('image/jpeg');

  // As a blob
  return new Promise(resolve => {
    canvas.toBlob(file => {
      resolve(URL.createObjectURL(file))
    }, `image/${getImageExtension}`)
  })
}

const CropperImage = ({name, file, addImage, closeCropper, uploadImage, aspect}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [Base64, setBase64] = useState('')
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [croppedImage, setCroppedImage] = useState(null)
  const [modal, setModal] = useState(false)
  const firstRender = useRef(true)
  const condition = (file !== undefined && addImage == true)
  const { t } = useTranslation();

  useEffect(() => {
    setModal(addImage)
    imageToBase64(file)
  }, [condition])

  useEffect(() => {
    if(firstRender.current){
      firstRender.current = false;
    }
    else{
      uploadImage(croppedImage)
    }
  }, [croppedImage])

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])

  const showCroppedImage = useCallback(async () => {
    let croppedImage = null
    try {
      croppedImage = await getCroppedImg(
        Base64,
        croppedAreaPixels
      )
      setCroppedImage(croppedImage)
    } catch (e) {
      console.error(e)
    }
  }, [croppedAreaPixels, croppedImage])

  const imageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      if(file instanceof Blob){
        reader.onerror = () => {
          reject("Err")
        }
        reader.onload = () => {
          if(reader.result !== undefined){
            resolve(setBase64(reader.result));
          }
          else{
            reject("Err")
          }
        }

        reader.readAsDataURL(file)
      }
    })
  }

  const closeModal = () => {
    setModal(false);
    closeCropper();
  };
  return (
    <Modal
      header={t('jbc-front.components.ImageCropper.header')}
      isOpen={modal}
      body={
        <div style={{ display: 'flex', position: 'relative', width: '100%', height: '400px', zIndex: '1' }}>
          <Cropper
            image={`${Base64}`}
            crop={crop}
            zoom={zoom}
            aspect={aspect || 1}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </div>
      }
      cancel={t('jbc-front.components.ImageCropper.cancel')}
      submit={t('jbc-front.components.ImageCropper.submit')}
      onSubmit={showCroppedImage}
      hideModal={() => closeModal()}
    />
  );
};

export class renderImageField extends Component {
  static defaultProps = {
    accepted: '*',
    multiple: false,
    disablePreview: false
  }

  constructor(props){
    super(props)
    this.state = {
      addImage: false
    }
  }

  onDrop = acceptedFiles => {
    if (acceptedFiles) {
      this.setState({ files: acceptedFiles[0], addImage: true })
    }
    // const { multiple, input: { onChange, value } } = this.props
    // files._id = uniqueId('file_')
    // return multiple ? onChange([...value, ...acceptedFiles]) : onChange(acceptedFiles[0])
  }

  handleBlur = () => {
    const { input: { onBlur, value } } = this.props
    return onBlur(value)
  }

  clear = () => {
    const { input: { onChange } } = this.props
    return onChange(null)
  }

  remove = index => {
    const { input: { value, onChange } } = this.props
    onChange(value.filter((file, i) => i !== index))
  }

  closeCropper = () => {
    this.setState({
      addImage: false
    })
  }

  render() {
    /* eslint-disable no-unused-vars */
    const {
      required,
      meta,
      label,
      input,
      accept,
      multiple,
      note,
      noteWidth,
      disabled,
      disablePreview,
      diff,
      changed,
      description,
      isChangeLabelToAnchor,
      noValuePreview,
      uploadImage,
      aspect,
      removeImage
    } = this.props
    const {onChange, addImage, files} = this.state
    /* eslint-enable no-unused-vars */
    // const Preview = this.props.preview
    return (
      <div className={styles.btnImage}>
        <Label
          text={label}
          required={required}
          note={note}
          noteWidth={noteWidth}
          changed={changed}
          diff={diff}
          isChangeLabelToAnchor={isChangeLabelToAnchor}
        />
        {!disabled && (
          <Dropzone
            accept={accept}
            onBlur={this.handleBlur}
            onDrop={this.onDrop}
            name={name}
            multiple={multiple}
            className="dropzone-input"
            disablePreview={disablePreview}>
            <div className={styles.btnTextarea}>
              <i>
                Upload Image
              </i>
              {/* <input
                type="text"
                className={meta.error && meta.touched ? styles.invalid : ''}
                readOnly
                placeholder={this.props.t('jbc-front.components.Form.Select_file_or_drag_and_drop')}
                value=""
              /> */}
            </div>
          </Dropzone>
        )}
          <span className={styles.delete}>
            <Delete onClick={removeImage} size={25} />
          </span>
          <CropperImage name={input.name} file={files} addImage={addImage} closeCropper={this.closeCropper} uploadImage={uploadImage} aspect={aspect}/>
        {/* {!noValuePreview && value &&
          (
            <img src={ImageLoad(value)}/>
          )
        } */}
      </div>
    )
  }
}

export const BoxDouble = ({ children }) => <div className={styles.double}>{children}</div>

export const BoxTriple = ({ children }) => <div className={styles.triple}>{children}</div>

export const BoxInner = ({ children }) => <div className={styles.inner}>{children}</div>

export const Section = ({ title, children, error, icon, note, small, ...rest }) => (
  <section className={error ? `${styles.boxError}` : `${styles.box}`} {...rest}>
    {title && (
      <div className={small ? styles.boxHeadSmall : styles.boxHead}>
        {title}
        {note && <span className={styles.boxHeadNote}>{note}</span>}
        {icon && <span className={styles.boxHeadIcon}>{icon}</span>}
      </div>
    )}
    <div className={small ? styles.boxMainSmall : styles.boxMain}>{children}</div>
  </section>
)

export const dateFieldProps = {
  normalize: value => (isObject(value) && value.format ? value.format('DD/MM/YYYY') : value || ''),
  format: value => (isString(value) ? value.replace(/^(\d{2})-(\d{2})-(\d{4}).*$/, '$1/$2/$3') : value || ''),
  validate: validators.date
};

const monthFieldProps = {
  viewMode: 'months',
  dateFormat: 'YYYY/MM',
  normalize: value => (isObject(value) && value.format ? value.format('MM/YYYY') : value || ''),
  format: value => (isString(value) ? value.replace(/^(\d{4})-(\d{2})-(\d{2}).*$/, '$1/$2') : value || ''),
  validate: validators.monthYear
}

const validateToArray = validate => (validate && !isArray(validate) ? [validate] : validate || [])

const makeField = (component, type = 'text', otherProps = {}) => props => {
  const { refField, required, validate, label, name, note, noteWidth, ...rest } = { ...otherProps, ...props }
  return (
    <div className={styles.boxWrap}>
      <Field
        type={type}
        component={component}
        validate={[...validateToArray(validate), validators.requiredIf(required)]}
        required={required}
        ref={refField}
        name={name}
        label={label}
        note={note}
        noteWidth={noteWidth}
        {...rest}
      />
      <LabelMapper name={name} label={label} />
    </div>
  )
}

export const TextField = makeField(renderInputField)

export const DateField = makeField(renderDatePickerField, 'text', dateFieldProps)

export const MonthField = makeField(renderDatePickerField, 'text', monthFieldProps)

export const SelectField = makeField(renderSelectField)

export const CreatableField = makeField(renderSelectField, 'text', { creatable: true })

export const TextFieldWithKana = makeField(renderInputFieldWithKana)

export const RadioField = makeField(renderRadioField)

export const RadioFieldWithIssuedDate = makeField(renderRadioFieldWithIssuedDate)

export const CheckboxField = makeField(renderCheckBoxField, 'checkbox')

export const FileField = withTranslation('translation')((Field => props => (
  <Field {...props} validate={props.label ? validators.sizeBelow : validators.sizeBelowNoLabel} />
))(makeField(renderFileField)))

export const ImageField = withTranslation('translation')((Field => props => (
  <Field {...props} validate={props.label ? validators.sizeBelow : validators.sizeBelowNoLabel} />
))(makeField(renderImageField)))

export const TextAreaField = makeField(renderTextAreaField)

const withErrorField = Content => {
  const name = prefix => (prefix ? `_${prefix}` : '_fields')
  const renderContent = ({ meta, label, prefix, input, required, note, noteWidth, ...rest }) => (
    <div className={styles.boxWrap}>
      <Label text={label} required={required} note={note} noteWidth={noteWidth} />
      <div className={meta.touched && meta.error ? styles.invalid : undefined}>
        <Content {...rest} label={label} prefix={prefix} required={required} onBlur={() => input.onBlur()} />
      </div>
      <Error meta={meta} label={label} />
      <LabelMapper name={name(prefix)} label={label} />
    </div>
  )
  return ({ fieldsValidate, ...rest }) => (
    <Field validate={fieldsValidate} component={renderContent} name={name(rest.prefix)} {...rest} />
  )
}

export const NumberFields = ({
  label,
  prefix,
  required,
  texts,
  lengths,
  exactLength,
  needNumber = true,
  seperateChar = '_',
  indexOffset = 0,
  onBlur,
  note,
  noteWidth,
  diff,
  changed,
  disabled,
  description,
  isChangeLabelToAnchor,
  withOption,
  noSuffix,
  ...rest
}) => (
  <div className={styles.boxWrap}>
    <Label
      text={label}
      required={required}
      note={note}
      noteWidth={noteWidth}
      changed={changed}
      diff={diff}
      isChangeLabelToAnchor={isChangeLabelToAnchor}
    />
    {lengths.map((len, index) => {
      const name = noSuffix ? `${prefix}` : `${prefix}${seperateChar}${index + indexOffset}`
      const text = index >= texts.length ? last(texts) : texts[index]
      return (
        <span key={`field_${name}`}>
          {text}
          <Field
            key={name}
            name={name}
            type="text"
            component={renderInlineInputField}
            // width={prefix.match(/(.*tel.*)/) ? 10 * len  + 5 : 15 * len + 20}
            maxLength={len}
            onBlur={onBlur}
            validate={ prefix.match(/(.*tel.*)/) ? [
              needNumber ? validators.number : validators.constUndef,
              validators.exactLengthNumber(exactLength ? len : null),
              validators.requiredIf(required),
              customValidators.phoneNumber
            ] : prefix.match(/(.*postalCode)/) ? [
              needNumber ? validators.number : validators.constUndef,
              validators.exactLengthNumber(exactLength ? len : null),
              validators.requiredIf(required),
              customValidators.isPostalCode
            ] : [
              needNumber ? validators.number : validators.constUndef,
              validators.exactLengthNumber(exactLength ? len : null),
              validators.requiredIf(required)
            ]}
            required={required}
            disabled={disabled}
            {...rest}
          />
          <LabelMapper name={name} label={`${label}の${index + 1}番`} />
        </span>
      )
    })}
    {texts.length > lengths.length && texts[lengths.length]}
    {lengths.map((len, index) => {
      const name = noSuffix ? `${prefix}` : `${prefix}${seperateChar}${index + indexOffset}`
      return (
        <Field
          name={name}
          component={Error}
          key={`error_${name}`}
          // label={`${label}の${index + 1}番`}
          label={`${label}`}
          validate={ prefix.match(/(.*tel.*)/) ? [
            needNumber ? validators.number : validators.constUndef,
            validators.exactLengthNumber(exactLength ? len : null),
            validators.requiredIf(required),
            customValidators.phoneNumber
          ] : prefix.match(/(.*postalCode)/) ? [
            needNumber ? validators.number : validators.constUndef,
            validators.exactLengthNumber(exactLength ? len : null),
            validators.requiredIf(required),
            customValidators.isPostalCode
          ] : [
            needNumber ? validators.number : validators.constUndef,
            validators.exactLengthNumber(exactLength ? len : null),
            validators.requiredIf(required)
          ]}
          required={required}
        />
      )
    })}
    <Diff diff={diff} />
    {description && <div className={styles.description}>{description}</div>}
  </div>
)

export const DateSpanFields = withErrorField(({ label, prefix, fieldProps, onBlur }) => {
  const { validate, ...rest } = dateFieldProps
  const withDateValidate = [validators.date, validate]
  const start_on = prefix ? `${prefix}_start_on` : 'start_on'
  const end_on = prefix ? `${prefix}_end_on` : 'end_on'
  return (
    <React.Fragment>
      <Field
        component={renderInlineDatePickerField}
        type="text"
        name={start_on}
        validate={withDateValidate}
        onBlur={onBlur}
        width={236}
        {...rest}
        {...(fieldProps ? fieldProps[0] : {})}
      />
      &nbsp;〜&nbsp;
      <Field
        component={renderInlineDatePickerField}
        type="text"
        name={end_on}
        validate={withDateValidate}
        onBlur={onBlur}
        width={236}
        {...rest}
        {...(fieldProps ? fieldProps[1] : {})}
      />
      <Field name={start_on} component={Error} label={`${label}の開始日`} validate={withDateValidate} {...rest} />
      <LabelMapper name={start_on} label={`${label}の開始日`} />
      <Field name={end_on} component={Error} label={`${label}の終了日`} validate={withDateValidate} {...rest} />
      <LabelMapper name={end_on} label={`${label}の終了日`} />
    </React.Fragment>
  )
})

export const CheckboxFields = ({ label, options }) => (
  <div className={styles.boxWrap}>
    <Label text={label} />
    {options.map(({ name, label }) => (
      <label key={`${name}_checkbox`} className="input-label">
        <Field component="input" type="checkbox" name={name} className="m-checkbox-input" />
        <span className="m-checkbox-parts">{label}</span>
      </label>
    ))}
  </div>
)

export const DoubleTextField = ({ isReverse, fields = [], required = true, fieldProps = {} }) => {
  const orderedFieldName = isReverse ? [...fields].reverse() : fields;
  return (
    <BoxDouble>
      {orderedFieldName.map(field => <TextField key={field.name} name={field.name} label={field.label} required={required} {...fieldProps[field.name]} />)}
    </BoxDouble>
  );
};
